var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMicOff16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_11376_3399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0841 8.3417L6.1445 3.40215C6.58426 2.56836 7.45969 2 8.46787 2C9.91762 2 11.0929 3.17525 11.0929 4.625V8.125C11.0929 8.19797 11.0899 8.27024 11.0841 8.3417ZM5.84287 7.08562V8.125C5.84287 9.57475 7.01812 10.75 8.46787 10.75C8.77882 10.75 9.07714 10.6959 9.35394 10.5967L10.1828 11.4256C9.66968 11.6927 9.08641 11.8438 8.46787 11.8438C6.41406 11.8438 4.74912 10.1788 4.74912 8.125C4.74912 7.76256 4.45531 7.46875 4.09287 7.46875C3.73043 7.46875 3.43662 7.76256 3.43662 8.125C3.43662 10.6067 5.23343 12.6688 7.5971 13.0812C7.59429 13.1058 7.59285 13.1309 7.59285 13.1563V15.3438C7.59285 15.7062 7.88666 16 8.2491 16C8.61154 16 8.90535 15.7062 8.90535 15.3438V13.1563L8.90508 13.1375C9.72288 13.0671 10.4848 12.8011 11.1437 12.3865L12.4056 13.6484C12.7181 13.9608 13.2246 13.9608 13.537 13.6484C13.8494 13.336 13.8494 12.8294 13.537 12.517L4.03756 3.01757C3.72514 2.70515 3.21861 2.70515 2.90619 3.01757C2.59377 3.32999 2.59377 3.83652 2.90619 4.14894L5.84287 7.08562ZM12.0083 9.26596L13.0177 10.2754C13.3264 9.62334 13.4991 8.89434 13.4991 8.125C13.4991 7.76256 13.2053 7.46875 12.8429 7.46875C12.4804 7.46875 12.1866 7.76256 12.1866 8.125C12.1866 8.52302 12.1241 8.90644 12.0083 9.26596Z",
    fill: "white",
    fillOpacity: 0.92
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_11376_3399",
    x: -1.5,
    y: -1,
    width: 20,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11376_3399"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11376_3399",
    result: "effect2_dropShadow_11376_3399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11376_3399",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMicOff16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-mic_off-16.34612d5c10a51a573edd0b3d7f5e064f.svg";